"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpRpcRequest = void 0;
const cq_core_1 = require("@leavy/cq-core");
const result_1 = require("@leavy/result");
const errors_1 = require("./errors");
const RpcRequest_1 = require("./RpcRequest");
const HttpContextHeaders_1 = require("./HttpContextHeaders");
/**
 * Send the Remote Procedure Invocation request using the HTTP protocol
 */
class HttpRpcRequest extends RpcRequest_1.RpcRequest {
    constructor(invocation, invocationSettings, http, url, verb, formDataSerializer, headers) {
        super(RpcRequest_1.RequestProtocol.Http);
        this.invocation = invocation;
        this.invocationSettings = invocationSettings;
        this.http = http;
        this.url = url;
        this.verb = verb;
        this.formDataSerializer = formDataSerializer;
        this.headers = headers;
    }
    async send(context) {
        var _a, _b;
        try {
            const headers = {
                ...this.headers,
            };
            const config = {
                method: this.verb,
                url: `${this.url}${this.url.endsWith("/") ? "" : "/"}${encodeURIComponent(this.invocationSettings.name)}`,
                data: this.invocation,
                headers,
            };
            if (this.verb === "GET" || this.verb === "DELETE") {
                config.params = this.invocation;
            }
            else {
                config.data = this.invocation;
            }
            if (context) {
                headers[HttpContextHeaders_1.HttpContextHeaders.CORRELATION_ID] = context.correlationId;
                headers[HttpContextHeaders_1.HttpContextHeaders.EXECUTION_ID] = context.executionId;
                if (context.actorId) {
                    headers[HttpContextHeaders_1.HttpContextHeaders.ACTOR_ID] = context.actorId;
                }
            }
            if (this.invocationSettings.binaryProperties) {
                headers["Content-Type"] = "multipart/form-data";
                if (!this.formDataSerializer) {
                    throw new Error("Could not serialize multipart/form-data: the FormData serializer is not provided");
                }
                config.data = this.formDataSerializer.serialize(this.invocation);
            }
            else {
                headers["Content-Type"] = "application/json";
            }
            const response = await this.http.request(config);
            return {
                type: cq_core_1.InvocationResultType.Succeeded,
                result: result_1.Ok(response.data),
            };
        }
        catch (e) {
            const { response } = e;
            if (response && response.status) {
                // On 400 status code, depending on the Bad result reason, the result can be a success with a bad result or a validation failure
                if (response.status === 400) {
                    const badResult = result_1.Bad((_a = response.data) === null || _a === void 0 ? void 0 : _a.reason, (_b = response.data) === null || _b === void 0 ? void 0 : _b.value);
                    // Filter on invocation request errors an throw theme
                    if (typeof badResult.reason === "string" && badResult.reason.startsWith(`${HttpRpcRequest.REQUEST_FAILURE_PREFIX}:`)) {
                        const message = badResult.reason.split(":")[1];
                        throw new errors_1.HttpError(response.status, message !== null && message !== void 0 ? message : "");
                    }
                    // Test if it's a validation failure
                    if (badResult.reason === "VALIDATION_FAILED") {
                        return {
                            type: cq_core_1.InvocationResultType.Invalid,
                            validationResult: badResult.value,
                        };
                    }
                    // success with bad result otherwise
                    return {
                        type: cq_core_1.InvocationResultType.Succeeded,
                        result: badResult,
                    };
                }
                const message = response.data !== undefined
                    ? typeof response.data === "string"
                        ? response.data
                        : JSON.stringify(response.data, null, 2)
                    : response.statusText;
                if (response.status > 400 && response.status !== 500) {
                    throw new errors_1.HttpError(response.status, message);
                }
                return {
                    type: cq_core_1.InvocationResultType.Error,
                    error: new Error(message),
                };
            }
            throw new errors_1.NetworkError(e);
        }
    }
}
exports.HttpRpcRequest = HttpRpcRequest;
HttpRpcRequest.REQUEST_FAILURE_PREFIX = "INVOCATION_REQUEST_FAILURE";
//# sourceMappingURL=HttpRpcRequest.js.map